module.exports = __webpack_public_path__ + "static/media/Checkbox_empty.195b4c92.svg";